import { useCallback, useMemo } from "react";
import { AreaComumResponse } from "../typings";
import { showErrorAxios } from "infra/helpers/alerta";
import { Switch } from "@chakra-ui/react";
import { useToggleAreaComumStatus } from ".";
import { useCurrentTenant } from "core/features/auth/tenant.store";
import { formatAreaComumValor } from "infra/helpers/formatAreaComumValor";

function useAreaComumColumns({ onToogled }: { onToogled: () => void }) {
  const { tenant } = useCurrentTenant();

  const { isLoading, mutate: handleToggleStatus } = useToggleAreaComumStatus(
    tenant?.id as string
  );

  const _handleToggleStatus = useCallback(
    (id: string, checked: boolean) => {
      handleToggleStatus(
        { nextStatus: checked, id },
        {
          onError: (err) => {
            showErrorAxios(
              err,
              "Não foi possível alterar o status da área em comum."
            );
          },
          onSuccess: () => {
            onToogled();
          },
        }
      );
    },
    [handleToggleStatus, onToogled]
  );

  return useMemo(() => {
    return [
      {
        title: "Nome",
        dataIndex: "nome",
      },
      {
        title: "Tipo",
        dataIndex: "tipoAreaComum",
      },
      {
        title: "Capacidade Máxima",
        dataIndex: "capacidadeMaxima",
      },
      {
        title: "Valor",
        render: (original: AreaComumResponse) => (
          <div>
            {formatAreaComumValor(
              original.valor,
              original.valorMinimo,
              original.valorMaximo
            )}
          </div>
        ),
      },
      {
        title: "Status",
        render: (original: AreaComumResponse) => (
          <div>
            <Switch
              isDisabled={isLoading}
              onChange={() => {
                _handleToggleStatus(original.id, !original.ativo);
              }}
              isChecked={!!original.ativo}
            />
          </div>
        ),
      },
    ];
  }, [_handleToggleStatus, isLoading]);
}

export default useAreaComumColumns;
